export default __webpack_public_path__ + "home-garden.855beb42fcca160a9b9366ee4c30bd3e.png";